import React from 'react';
const facts = [{
  value: '52',
  label: 'Weekly classes, ready to teach',
  color: 'text-coral-deep'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses',
  color: 'text-indigo'
}, {
  value: '3',
  label: 'Levels for every skill',
  color: 'text-teal-deep'
}, {
  value: '4',
  label: 'Apparatus in every class',
  color: 'text-amber-deep'
}];
export function SocialProofBar() {
  return <section className="w-full bg-white" data-id="element-354" data-mp="32j4o4zy90h7e">
      <div className="max-w-6xl mx-auto px-5 py-10 sm:py-12" data-id="element-355" data-mp="32htj6wt2h3ep">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-cloud-dark bg-cloud-dark sm:grid-cols-4" data-id="element-356" data-mp="2xk9uf2yqt88i">
          {facts.map(fact => <div key={fact.label} className="bg-white px-4 py-5 text-center" data-id="element-357" data-mp="2tkj5z5wov475">
              <div className={`font-display text-4xl font-extrabold leading-none sm:text-5xl ${fact.color}`} data-id="element-358" data-mp="2oitr1f6ci6ds">{fact.value}</div>
              <div className="mt-1.5 text-[10px] font-semibold uppercase tracking-widest text-slate" data-id="element-359" data-mp="1i0wyboh7l5kc">{fact.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}